import { Card } from '@statsbomb/kitbag-components';
import { ReactNode } from 'react';

export const FullScreenCard = ({ children }: { children: ReactNode }) => (
  <div className="h-full my-2 md:m-2">
    <Card>{children}</Card>
  </div>
);
